
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ConfirmationMessage, enumMessageType } from '@/store/types';
import VuePerfectScrollbar from "vue-perfect-scrollbar";

@Component({
	components: {
		VuePerfectScrollbar
	}
})
export default class ConfirmationModal extends Vue {	
	@Prop() visible: boolean;
	@Prop() danger: boolean;
	@Prop() title: string;
	@Prop() okBtnText: string;
	@Prop() cancelBtnText: string;
	@Prop({ type: Boolean, default: true }) deletion: boolean;
	@Prop() messages: ConfirmationMessage[];

	private errorMessages : string[] = [];
	private warningMessages : string[] = [];
	private confirmationMessages : string[] = [];

	@Watch('messages')
	messageChanged() : void {
		this.errorMessages = [];
		this.warningMessages = [];
		this.confirmationMessages = [];

		if (this.messages.length > 0) {
			this.messages.forEach(message => {
				if(message.messageType == enumMessageType.error){
					this.errorMessages.push(message.text);
				}
				else if(message.messageType == enumMessageType.warning){
					this.warningMessages.push(message.text);
				}
				else if(message.messageType == enumMessageType.confirmation){
					this.confirmationMessages.push(message.text);
				}
			});
		}
	}
}
